import { enablePointerEvents } from '@utils/pointer-events-control';
import { config, gameState } from '@js/state';

var points;
var array;
var divide = false;
var joystickInput = false;

var joystickEnable = false;
var heliPosition = 644;
var attempts = 0;
var hintOn = false;

// var gameState.attempted= 1;
// var score = 0;
var lineLength = 917.14;
var unitLength = 0; //distance bw each division

var numberlineDivisions = 0;

var levelCorrect = false; // need to figure out

var clickCount = 0;

var heliMoveDuration = 1500; //check this fn. unitLengthCoverTime

var midpointsArray = [];

var bearwrongAnimationRunning = false; // to check if we need to remove the bear wrong animation after clicking

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: "GameScene",
    });
  }

  preload() {
    //data loaded in start scene
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    // this.tweens.add({
    //   targets: config.audio.heliaudio,
    //   volume: 0.002,
    //   duration: 3000,
    //   onComplete: () => {},
    // });

    for (let i = 1; i <= 10; i++) {
      config.audio["qa" + i] = this.sound.add("qa" + i).setVolume(0.3);
    }

    config.audio.yayaudio = this.sound.add("yayaudio").setVolume(0.05);

    this.add.sprite(config.width / 2, config.height / 2, "tutorialSceneBG").setDisplaySize(1280, 720);

    // this.numberLine = this.add.sprite((config.width / 2) + 3 , config.height - 180, "numberLine1").setScale(1);

    // this.numberLineForGameScene = this.add.sprite((config.width / 2) + 3.5, config.height - 194, "numberlineDiv8").setScale(1);

    // this.numberLineForGameScene = this.add.sprite(174,542.36, "numberlineDiv8").setScale(1.006).setOrigin(0);

    // this.numberLineForGameScene = this.add.sprite(174,513, "numberlineDiv8").setScale(1.006).setOrigin(0);

    // this.numberLineForGameScene = this.add.sprite(175.5,513, "numberlineDiv8").setScale(1.004).setOrigin(0);

    // this.numberLineForGameScene = this.add.sprite((config.width / 2) + 3.7, config.height - 175, "numberlineDiv8").setScale(1.004);

    // this.numberLineForGameScene = this.add.sprite((config.width / 2) + 3.9, config.height - 175, "numberlineDiv8").setScale();

    this.numberLineForGameScene = this.add.sprite(171.2, 513, "numberlineDiv8").setOrigin(0).setScale(1.004);

    this.numberline0and1 = this.add.sprite(175, 525, "numberline0and1").setOrigin(0).setScale(1.004);

    // this.numberLineForGameScene.setPosition(172.2,513).setScale(1.004);
    // this.numberLineForGameScene.setPosition(171,513).setScale(1.008);
    // this.numberLineForGameScene.setPosition(175.5,513).setScale(0.999);
    // this.numberLineForGameScene.setPosition(171,513).setScale(1.009);
    // this.numberLineForGameScene.setPosition(171,513).setScale(1.009);
    // this.numberLineForGameScene.setPosition(171.5,513).setScale(1.006);
    // this.numberLineForGameScene.setPosition(177,513).setScale(0.992));

    // below to be deleted, not serious

    if (gameState.attempted == 1 || gameState.attempted == 2) {
      this.numberLineForGameScene.setTexture("numberlineDiv8");
      this.numberLineForGameScene.setPosition(172.2, 513).setScale(1.004);
    } else if (gameState.attempted == 3) {
      this.numberLineForGameScene.setTexture("numberlineDiv3");
      this.numberLineForGameScene.setPosition(171, 513).setScale(1.008);
    } else if (gameState.attempted == 4 || gameState.attempted == 7) {
      this.numberLineForGameScene.setTexture("numberlineDiv10");
      this.numberLineForGameScene.setPosition(175.5, 513).setScale(0.999);
    } else if (gameState.attempted == 5) {
      this.numberLineForGameScene.setTexture("numberlineDiv4");
      this.numberLineForGameScene.setPosition(171, 513).setScale(1.009);
    } else if (gameState.attempted == 6 || gameState.attempted == 9) {
      this.numberLineForGameScene.setTexture("numberlineDiv6");
      this.numberLineForGameScene.setPosition(171, 513).setScale(1.009);
    } else if (gameState.attempted == 8) {
      this.numberLineForGameScene.setTexture("numberlineDiv5");
      this.numberLineForGameScene.setPosition(171.5, 513).setScale(1.006);
    } else if (gameState.attempted == 10) {
      this.numberLineForGameScene.setTexture("numberlineDiv12");
      this.numberLineForGameScene.setPosition(177, 513).setScale(0.992);
    }

    this.heliHover = this.physics.add.sprite(-200, 363, "heliHoverAnim").setScale(0.67).setDepth(1);

    this.anims.create({
      key: "hover",
      frames: this.anims.generateFrameNames("heliHoverAnim", {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: "HOVERINGHC",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: -1,
    });

    this.heliHover.play("hover");

    this.wrongheliHover = this.physics.add.sprite(-200, 363, "bearWrongAnim").setScale(0.67);

    this.anims.create({
      key: "wronghover",
      frames: this.anims.generateFrameNames("bearWrongAnim", {
        start: 0,
        end: 90,
        zeroPad: 0,
        prefix: "bearwrong",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.wrongheliHover.play("wronghover");

    // this.joystickHolder = this.add.sprite(config.width / 2 - 80, 850, "joystickHolder").setScale(0.67);

    // this.joystick = this.add
    //   .sprite(config.width / 2 - 60, 800, "joystickAnim")
    //   .setScale(0.67)
    //   .setFrame(0);

    this.dropButton = this.add.sprite(config.width / 2 + 80, 800, "dropButtonAnim").setScale(0.67);

    this.speechBubble = this.add
      .sprite(214, 170 + 63, "speechBubble")
      .setScale(0.67)
      .setAlpha(0)
      .setOrigin(0, 0.1);
    this.qBoard = this.add
      .sprite(214, 190 + 63, "qBoard")
      .setScale(0.67)
      .setOrigin(0, 1)
      .setAlpha(0);

    this.anims.create({
      key: "drop",
      frames: this.anims.generateFrameNames("heliDropAnim", {
        start: 0,
        end: 359,
        zeroPad: 0,
        prefix: "beardrop",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.dropButton = this.add.sprite(config.width / 2 + 80, 800, "dropButtonAnim").setScale(0.67);

    this.anims.create({
      key: "breatheDrop",
      frames: this.anims.generateFrameNames("dropButtonAnim", {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: "DROP Button breathig",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.checkButtonRight = this.add
      .sprite(config.width / 2 + 150, 650, "checkRightAnim")
      .setScale(0.67)
      .setVisible(false);

    this.anims.create({
      key: "correct",
      frames: this.anims.generateFrameNames("checkRightAnim", {
        start: 1,
        end: 32,
        zeroPad: 0,
        prefix: "CHECK RIGHT",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.checkButtonWrong = this.add
      .sprite(config.width / 2 + 150, 650, "checkWrongAnim")
      .setScale(0.67)
      .setVisible(false);

    this.anims.create({
      key: "wrong",
      frames: this.anims.generateFrameNames("checkWrongAnim", {
        start: 1,
        end: 42,
        zeroPad: 0,
        prefix: "checkwrong",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.checkConfetti = this.add.sprite(config.width / 2 + 75, 680, "checkConfettiAnim");

    this.anims.create({
      key: "confetti",
      frames: this.anims.generateFrameNames("checkConfettiAnim", {
        start: 0,
        end: 47,
        zeroPad: 0,
        prefix: "checkconfetti",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, "overlay")
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(false)
      .setInteractive();

    // this.hint = this.add.sprite(240, 575, "hint_1").setScale(0.8).setVisible(false).setDepth(6);

    this.hint = this.add.sprite(255, 552, "hint_1").setScale(0.8).setVisible(false).setDepth(6);

    this.closeHintButton = this.add.sprite(445, 450, "closeHint").setVisible(false).setDepth(6).setInteractive({ cursor: "pointer" });

    // this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(6).setInteractive({ cursor: "pointer" });

    this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(6);

    this.anims.create({
      key: "pop",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "breathe",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "idle",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "pop_out",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.score1 = this.add
      .sprite(935 - 8, 43, "greenCircle")
      .setOrigin(0)
      .setVisible(true);
    this.score2 = this.add
      .sprite(969 - 8, 43, "greenCircle")
      .setOrigin(0)
      .setVisible(false);
    this.score3 = this.add
      .sprite(1003 - 8, 43, "greenCircle")
      .setOrigin(0)
      .setVisible(false);
    this.score4 = this.add
      .sprite(1037 - 8, 43, "greenCircle")
      .setOrigin(0)
      .setVisible(false);
    this.score5 = this.add
      .sprite(1071 - 8, 43, "greenCircle")
      .setOrigin(0)
      .setVisible(false);
    this.score6 = this.add
      .sprite(1105 - 8, 43, "greenCircle")
      .setOrigin(0)
      .setVisible(false);

    // this.leftJoystick = this.add.sprite(529, 578, "leftJoystick").setScale(1).setOrigin(0).setAlpha(0.01).setDepth(2);
    // this.rightJoystick = this.add.sprite(559, 578, "rightJoystick").setScale(1).setOrigin(0).setAlpha(0.01).setDepth(2);

    // this.leftJoystick = this.add.sprite(529, 2000, "leftJoystick").setScale(1).setOrigin(0).setAlpha(0.01).setDepth(2);
    // this.rightJoystick = this.add.sprite(559, 2000, "rightJoystick").setScale(1).setOrigin(0).setAlpha(0.01).setDepth(2);

    this.dropUp = this.add.sprite(669, 639, "dropUp").setOrigin(0);
    this.dropDown = this.add.sprite(669, 643, "dropDown").setOrigin(0).setVisible(false);

    this.leftUp = this.add.sprite(493, 643, "leftUp").setOrigin(0);
    this.leftDown = this.add.sprite(493, 647, "leftDown").setOrigin(0).setVisible(false);

    this.rightUp = this.add.sprite(568, 643, "rightUp").setOrigin(0);
    this.rightDown = this.add.sprite(568, 647, "rightDown").setOrigin(0).setVisible(false);

    // this.time.delayedCall(
    //   1,
    //   function () {
    //     this.controlsSlideIn([this.joystick], 800, 633);
    //     this.controlsSlideIn([this.joystickHolder, this.dropButton], 800, 670);

    //     // this.dropButton.setPosition(config.width / 2 + 80, 670);
    //   },
    //   [],
    //   this
    // );

    this.graphics = this.add.graphics();

    this.curve = new Phaser.Curves.Line(new Phaser.Math.Vector2(185, 515), new Phaser.Math.Vector2(1101.5, 515));

    this.linePoints = this.add.group();

    this.curve.draw(this.graphics);

    // this.numberLine.setFrame(0);

    array = this.linePoints.getChildren();

    divide = true;

    // if(gameState.attempted==1){
    //   this.startLevel(this.numberlineDivisions);
    // }

    // console.log(this.numberlineDivisions);

    this.findDivisions();
    // console.log(numberlineDivisions);
    // console.log(gameState.attempted);

    this.redDot = this.add.sprite(174, 542.36, "redPoint").setScale(0.7).setVisible(false).setDepth(2);

    this.startLevel(numberlineDivisions);

    this.handleJoysticks();

    // this.dropButton.setInteractive({ cursor: "pointer" });

    this.handleDropButton();

    this.handleHintButton();
  }

  /*---------Custom Functions---------*/

  toggleButton(target, targetpair, allowselectionfornew) {
    target.setVisible(false).removeInteractive();
    targetpair.setVisible(true).removeInteractive();

    if (allowselectionfornew) {
      targetpair.setInteractive({ cursor: "pointer" });
    }
  }

  handleDropButton() {
    this.dropUp.on(
      "pointerup",
      function (pointer) {
        joystickInput = false;
        // console.log(heliPosition-430);

        // this.qBoardAppear(214, 1, 0, 0.67, 0);
        // this.qBoardAppear(214, 1, 0, 1, 0);

        // this.joystick.x = config.width / 2 - 60;
        // this.joystick.setFrame(0);

        this.redDot.setVisible(false);

        // this.hintButton.removeInteractive();
        // this.rightJoystick.removeInteractive();
        // this.leftJoystick.removeInteractive();
        //isssue

        levelCorrect =
          (gameState.attempted == 1 && clickCount == 2) ||
          (gameState.attempted == 2 && clickCount == 6) ||
          (gameState.attempted == 3 && clickCount == 3) ||
          (gameState.attempted == 4 && clickCount == 2) ||
          (gameState.attempted == 5 && clickCount == 2) ||
          (gameState.attempted == 6 && clickCount == 2) ||
          (gameState.attempted == 7 && clickCount == 8) ||
          (gameState.attempted == 8 && clickCount == 3) ||
          (gameState.attempted == 9 && clickCount == 4) ||
          (gameState.attempted == 10 && clickCount == 6);

        // console.log(levelCorrect);

        if (levelCorrect) {
          // this.hintButton.setInteractive(false);
          // this.rightJoystick.setInteractive(false);
          // this.leftJoystick.setInteractive(false);
          config.audio.correctdropaudio.play();
          ////
          this.hintButton.removeInteractive();
          this.rightUp.removeInteractive();
          this.leftUp.removeInteractive();
          this.dropUp.removeInteractive();

          this.redDot.setVisible(false);

          // this.hintButton.removeInteractive();

          this.qBoardAppear(heliPosition - 430, 1, 1, 0, 0.67, 0);

          if (hintOn == true) {
            this.hintButton.play("pop_out");
            hintOn = false;
          }

          gameState.score = gameState.score + 1;

          // console.log("score: " + gameState.score);

          array[clickCount].setFrame(2);

          if (gameState.score == 1) {
            this.score2.setVisible(true);
          }
          if (gameState.score == 2) {
            this.score3.setVisible(true);
          }
          if (gameState.score == 3) {
            this.score4.setVisible(true);
          }
          if (gameState.score == 4) {
            this.score5.setVisible(true);
          }
          if (gameState.score == 5) {
            this.score6.setVisible(true);
          }
          // if(gameState.score == 6){this.score6.setVisible(true);}

          this.dropUp.setVisible(false);

          this.checkButtonRight.setVisible(true);

          this.checkButtonRight.setPosition(config.width / 2 + 80, 670);

          this.checkButtonRight.play("correct");

          this.checkConfetti.play("confetti");

          this.heliHover.setTexture("heliDropAnim");
          this.heliHover.play("drop");

          if (gameState.score >= 5) {
            this.time.delayedCall(
              4000,
              function () {
                this.cameras.main.fadeOut(1000, 255, 255, 255);
              },
              [],
              this
            );

            this.cameras.main.once(
              "camerafadeoutcomplete",
              function (camera) {
                this.cameras.main.fadeIn(1000, 255, 255, 255);
                gameState.gameWin = true;
                // console.log("Gameend");

                this.scene.stop("GameScene");
                this.scene.start("EndScene");
                config.audio.bgaudio.stop();
                config.audio.heliaudio.stop();
                config.audio.yayaudio.play();
              },
              this
            );
          }
          // else{
          //   this.changeQuestion();
          // }
          else {
            // this.tweens.add({
            //   targets: config.audio.heliaudio,
            //   delay: 2000,
            //   volume: 0,
            //   duration: 3000,
            //   onComplete: () => {},
            // });
            this.time.delayedCall(
              4000,
              function () {
                this.cameras.main.fadeOut(1000, 255, 255, 255);
                // this.tweens.add({
                //   targets: config.audio.heliaudio,
                //   volume: 0.002,
                //   delay: 1000,
                //   duration: 3000,
                //   onComplete: () => {},
                // });
              },
              [],
              this
            );

            this.cameras.main.once(
              "camerafadeoutcomplete",
              function (camera) {
                this.cameras.main.fadeIn(1000, 255, 255, 255);
                // this.scene.start("GameScene");

                // this.hintButton.removeInteractive();
                // this.rightJoystick.removeInteractive();
                // this.leftJoystick.removeInteractive();
                //tbc

                this.changeQuestion();
              },
              this
            );
          }
        } else if (!levelCorrect) {
          config.audio.incorrectdropaudio.play();
          ////
          this.hintButton.removeInteractive();
          this.rightUp.removeInteractive();
          this.leftUp.removeInteractive();

          this.dropUp.removeInteractive();

          //need to change

          this.incorrectAttempt();
        }

        // else if(!levelCorrect){
        //   console.log("wrong drop");

        //   this.dropButton.setVisible(false);

        //   this.checkButtonWrong.setVisible(true);

        //   this.checkButtonWrong.setPosition(config.width / 2 + 80, 670);

        //   this.checkButtonWrong.play("wrong");

        //   this.heliHover.setTexture("bearWrongAnim");
        //   this.heliHover.play("wronghover");

        //         if(gameState.score>=5){

        //           gameState.gameWin = true;

        //           console.log("Gameend")
        //           this.scene.stop("GameScene");
        //           this.scene.start("EndScene");

        //         }
        //         // else{
        //         //   this.changeQuestion();
        //         // }

        // else{

        //   this.time.delayedCall(
        //     4000,
        //     function () {
        //       this.cameras.main.fadeOut(1000, 255, 255, 255);
        //     },
        //     [],
        //     this
        //   );

        //   this.cameras.main.once(
        //     "camerafadeoutcomplete",
        //     function (camera) {
        //       this.cameras.main.fadeIn(1000, 255, 255, 255);
        //       // this.scene.start("GameScene");
        //       this.changeQuestion();
        //     },
        //     this
        //   );
        // }

        // }
      },
      this
    );
  }

  handleHintButton() {
    this.hintButton.on(
      "pointerup",
      function (pointer) {
        // this.rightJoystick.removeInteractive();
        // this.leftJoystick.removeInteractive();
        // this.dropButton.removeInteractive();
        config.audio.hintaudio.play();

        ////
        gameState.hints += 1;

        this.hintButton.play("idle");

        this.dropUp.removeInteractive();
        this.hintButton.removeInteractive();
        this.leftUp.removeInteractive();
        this.rightUp.removeInteractive();

        if (attempts == 1) {
          this.hint.setTexture("hint_1");

          this.overlay.setVisible(true).setDepth(5);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.overlay.setVisible(true).setDepth(5);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setTexture("hint_2");
        }
      },
      this
    );

    this.closeHintButton.on(
      "pointerup",
      function (pointer) {
        this.heliHover.setTexture("heliHoverAnim");
        this.heliHover.play("hover");

        this.rightUp.setInteractive({ cursor: "pointer" });
        this.leftUp.setInteractive({ cursor: "pointer" });
        this.dropUp.setInteractive({ cursor: "pointer" });

        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play("pop_out");

        hintOn = false;
      },
      this
    );
  }

  incorrectAttempt() {
    // correctAnswer = false;
    this.hintButton.setVisible(false);

    this.dropUp.setVisible(false);

    // this.dropUp.setInteractive(false);

    // this.leftUp.setInteractive(false);
    // this.rightUp.setInteractive(false);


    this.dropUp.removeInteractive();

    this.leftUp.removeInteractive();
    this.rightUp.removeInteractive();

    attempts += 1;
    //console.log(attempts);

    this.redDot.setVisible(true);

    // this.shape1.removeInteractive();
    // this.shape2.removeInteractive();
    // this.shape3.removeInteractive();
    // this.shape4.removeInteractive();

    // this.rightJoystick.removeInteractive();
    // this.leftJoystick.removeInteractive();
    // this.dropButton.removeInteractive();

    this.dropUp.setVisible(false);

    this.checkButtonWrong.setVisible(true);

    this.checkButtonWrong.setPosition(config.width / 2 + 80, 670);

    this.checkButtonWrong.play("wrong");

    this.heliHover.setTexture("bearWrongAnim");
    this.heliHover.play("wronghover");

    this.bearwrongAnimationRunning = true;

    this.time.delayedCall(
      1000,
      function () {
        // this.heliHover.setTexture("heliHoverAnim");

        if (attempts == 1 || attempts == 2) {
          hintOn = true;

          this.hintButton.setVisible(true);

          this.hintButton.play("pop");

          this.dropUp.setInteractive({ cursor: "pointer" });
          // this.hintButton.setInteractive({ cursor: "pointer" });
          this.leftUp.setInteractive({ cursor: "pointer" });
          this.rightUp.setInteractive({ cursor: "pointer" });

          this.time.delayedCall(
            1300,
            () => {
              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );
        }

        // this.rightJoystick.setInteractive({ cursor: "pointer" });
        // this.leftJoystick.setInteractive({ cursor: "pointer" });
        // this.dropButton.setInteractive({ cursor: "pointer" });
      },
      [],
      this
    );

    this.time.delayedCall(
      1500,
      function () {
        if (hintOn) {
          this.hintButton.play("breathe");
        }
      },
      [],
      this
    );

    this.time.delayedCall(
      1800,
      function () {
        if (attempts == 1 || attempts == 2) {
          // this.rightJoystick.setInteractive({ cursor: "pointer" });
          // this.leftJoystick.setInteractive({ cursor: "pointer" });
          // this.dropButton.setInteractive({ cursor: "pointer" });

          this.dropUp.setInteractive({ cursor: "pointer" });
          // this.hintButton.setInteractive({ cursor: "pointer" });
          this.leftUp.setInteractive({ cursor: "pointer" });
          this.rightUp.setInteractive({ cursor: "pointer" });

          this.dropUp.setVisible(true);

          this.checkButtonWrong.setVisible(false);

          this.checkButtonWrong.setPosition(config.width / 2 + 80, 670);

          this.time.delayedCall(
            1300,
            () => {
              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );
        }
      },
      [],
      this
    );

    // this.time.delayedCall(
    //   1800,
    //   function () {

    //     this.heliHover.setTexture("heliHoverAnim");
    //     this.heliHover.play("hover");
    //     bearwrongAnimationRunning = false;

    //   },
    //   [],
    //   this
    // );

    this.heliHover.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE,
      function () {
        this.heliHover.setTexture("heliHoverAnim");
        this.heliHover.play("hover");
        bearwrongAnimationRunning = false;
      },
      this
    );

    if (attempts == 3) {
      // this.dropButton.removeInteractive();
      this.hintButton.removeInteractive();
      this.leftUp.removeInteractive();
      this.rightUp.removeInteractive();
      this.dropUp.removeInteractive();

      // this.qBoardAppear(heliPosition-430, 1, 1, 0, 0.67,0);

      if (hintOn == true) {
        this.hintButton.play("pop_out");
        hintOn = false;

        // this.rightJoystick.removeInteractive();
        // this.leftJoystick.removeInteractive();
        // this.dropButton.removeInteractive()
      }

      // this.tweens.add({
      //   targets: config.audio.heliaudio,
      //   delay: 2000,
      //   volume: 0,
      //   duration: 3000,
      //   onComplete: () => {
      //     //heliaudio.setVolume(0.5);
      //   },
      // });

      this.time.delayedCall(
        3000,
        function () {
          this.time.delayedCall(
            1000,
            function () {
              this.cameras.main.fadeOut(1000, 255, 255, 255);
            },
            [],
            this
          );

          this.cameras.main.once(
            "camerafadeoutcomplete",
            function (camera) {
              attempts = 0;
              // this.tweens.add({
              //   targets: config.audio.heliaudio,
              //   volume: 0.002,
              //   delay: 500,
              //   duration: 3000,
              //   onComplete: () => {
              //     //heliaudio.setVolume(0.5);
              //   },
              // });

              this.dropUp.removeInteractive();
              this.hintButton.removeInteractive();
              this.leftUp.removeInteractive();
              this.rightUp.removeInteractive();

              this.qBoardAppear(214, 0.001, 0, 0, 0, 0);

              this.cameras.main.fadeIn(1000, 255, 255, 255);

              this.qBoard.x = 214;
              this.qBoard.setAlpha = 0;
              this.qBoard.setScale = 0;

              this.qBoardAppear(214, 0.001, 0, 0, 0, 0);

              // this.scene.start("GameScene");
              this.changeQuestion();
            },
            this
          );

          if (gameState.attempted == 10) {
            gameState.gameWin = false;
            this.scene.stop("TutorialScene");
            config.audio.heliaudio.stop();
            config.audio.bgaudio.stop();
            this.scene.start("EndScene");
          }
        },
        [],
        this
      );

      this.time.delayedCall(
        3300,
        function () {
          attempts = 0;

          this.dropUp.removeInteractive();
          this.hintButton.removeInteractive();
          this.leftUp.removeInteractive();
          this.rightUp.removeInteractive();
        },
        [],
        this
      );
    }
    //add end screen check all line length
  }

  changeQuestion() {

    this.dropUp.removeInteractive();
    this.hintButton.removeInteractive();
    this.leftUp.removeInteractive();
    this.rightUp.removeInteractive();
    
    this.redDot.setVisible(false);

    this.time.delayedCall(
      1,
      function () {
        gameState.attempted = gameState.attempted + 1;
        levelCorrect = false;
        // console.log(gameState.attempted);

        if (gameState.attempted <= 10) {
          if (gameState.attempted == 1 || gameState.attempted == 2) {
            this.numberLineForGameScene.setTexture("numberlineDiv8");
            this.numberLineForGameScene.setPosition(172.2, 513).setScale(1.004);
          } else if (gameState.attempted == 3) {
            this.numberLineForGameScene.setTexture("numberlineDiv3");
            this.numberLineForGameScene.setPosition(171, 513).setScale(1.008);
          } else if (gameState.attempted == 4 || gameState.attempted == 7) {
            this.numberLineForGameScene.setTexture("numberlineDiv10");
            this.numberLineForGameScene.setPosition(175.5, 513).setScale(0.999);
          } else if (gameState.attempted == 5) {
            this.numberLineForGameScene.setTexture("numberlineDiv4");
            this.numberLineForGameScene.setPosition(171, 513).setScale(1.009);
          } else if (gameState.attempted == 6 || gameState.attempted == 9) {
            this.numberLineForGameScene.setTexture("numberlineDiv6");
            this.numberLineForGameScene.setPosition(171, 513).setScale(1.009);
          } else if (gameState.attempted == 8) {
            this.numberLineForGameScene.setTexture("numberlineDiv5");
            this.numberLineForGameScene.setPosition(171.5, 513).setScale(1.006);
          } else if (gameState.attempted == 10) {
            this.numberLineForGameScene.setTexture("numberlineDiv12");
            this.numberLineForGameScene.setPosition(177, 513).setScale(0.992);
          }

          // this.points.destroy();

          // this.linePoints.destroy();
          this.linePoints.setVisible(false);

          this.dropUp.setVisible(true);

          this.checkButtonRight.setVisible(false);
          this.checkButtonWrong.setVisible(false);

          this.checkButtonRight.setPosition(config.width / 2 + 80, 670);
          this.checkButtonWrong.setPosition(config.width / 2 + 80, 670);

          this.findDivisions();
          this.startLevel(numberlineDivisions);
        } else {
          // console.log("Qn over");

          this.scene.stop("GameScene");
          this.scene.start("EndScene");
          config.audio.bgaudio.stop();
          config.audio.yayaudio.play();
        }
      },
      [],
      this
    );
  }

  handleJoysticks() {
    this.rightUp.on("pointerdown", () => {
      this.redDot.setVisible(false);

      joystickInput = true;
      // this.joystick.x = config.width / 2 - 60 + 8;
      // this.joystick.setFrame(2);

      if (heliPosition + this.unitLength <= 1561.14) {
        this.qBoardAppear(heliPosition - 430, 1, 1, 0, 0.67, 0);
      }

      if (this.bearwrongAnimationRunning == true) {
        this.heliHover.setTexture("heliHoverAnim");
        this.heliHover.play("hover");
        bearwrongAnimationRunning = false;
      }
    });

    this.leftUp.on("pointerdown", () => {
      this.redDot.setVisible(false);

      joystickInput = true;
      // this.joystick.x = config.width / 2 - 60 - 50;
      // this.joystick.setFrame(1);
      if (644 <= heliPosition - this.unitLength) {
        this.qBoardAppear(heliPosition - 430, 1, 1, 0, 0.67, 0);
      }

      if (this.bearwrongAnimationRunning == true) {
        this.heliHover.setTexture("heliHoverAnim");
        this.heliHover.play("hover");
        bearwrongAnimationRunning = false;
      }
    });

    this.rightUp.on("pointerup", () => {
      // console.log(heliPosition + this.unitLength);

      this.redDot.setVisible(false);

      // this.joystick.x = config.width / 2 - 60;
      // this.joystick.setFrame(0);

      this.findDivisions();

      if (heliPosition + this.unitLength <= 1561.14) {
        this.qBoardAppear(heliPosition - 430, 1, 1, 0, 0.67, 0);

        this.rightUp.removeInteractive();
        this.leftUp.removeInteractive();
        this.dropUp.removeInteractive();
        // console.log(this.heliHover.x);

        clickCount = clickCount + 1;
        // console.log("click count: " + clickCount);

        this.findDivisions();
        this.unitLengthCoverTime();

        this.heliSnap(heliMoveDuration, heliPosition, this.unitLength);

        //  alert( heliPosition + " " + this.unitLength);

        // this.joystick.x = config.width / 2 - 60;
        // this.joystick.setFrame(0);
        //tbc

        this.time.delayedCall(
          heliMoveDuration,
          function () {
            this.qBoardAppear(heliPosition - 430, 1, 0, 1, 0, 0.67);
            heliPosition = heliPosition + this.unitLength;

            this.rightUp.setInteractive({ cursor: "pointer" });
            this.leftUp.setInteractive({ cursor: "pointer" });

            this.dropUp.setInteractive({ cursor: "pointer" });
          },
          [],
          this
        );
      }

      this.toggleButton(this.rightUp, this.rightDown, false);

      // if(this.heliPosition != 1561.14){
      //   this.rightJoystick.removeInteractive();
      //   this.leftJoystick.removeInteractive();
      //   this.dropButton.removeInteractive();
      // }
    });

    this.leftUp.on("pointerup", () => {
      this.redDot.setVisible(false);

      // console.log(heliPosition - this.unitLength);

      // this.joystick.x = config.width / 2 - 60;
      // this.joystick.setFrame(0);

      this.findDivisions();

      if (644 <= heliPosition - this.unitLength) {
        this.qBoardAppear(heliPosition - 430, 1, 1, 0, 0.67, 0);

        this.rightUp.removeInteractive();
        this.leftUp.removeInteractive();
        this.dropUp.removeInteractive();

        clickCount = clickCount - 1;
        // console.log("click count: " + clickCount);

        // console.log(this.heliHover.x);
        this.findDivisions();

        this.heliSnap(heliMoveDuration, heliPosition, -this.unitLength);

        // this.joystick.x = config.width / 2 - 60;
        // this.joystick.setFrame(0);

        this.time.delayedCall(
          heliMoveDuration,
          function () {
            this.qBoardAppear(heliPosition - 430, 1, 0, 1, 0, 0.67);

            heliPosition = heliPosition - this.unitLength;

            //tbc

            this.rightUp.setInteractive({ cursor: "pointer" });
            this.leftUp.setInteractive({ cursor: "pointer" });
            this.dropUp.setInteractive({ cursor: "pointer" });
          },
          [],
          this
        );
      }

      // if(this.heliPosition != 644){
      //   this.rightJoystick.removeInteractive();
      //   this.leftJoystick.removeInteractive();
      //   this.dropButton.removeInteractive();
      // }

      this.toggleButton(this.leftUp, this.leftDown, false);
    });
  }

  ///

  startLevel(divisions) {
    // this.rightJoystick.removeInteractive();
    // this.leftJoystick.removeInteractive();
    // this.dropButton.removeInteractive();

    // this.hintButton.setVisible(false).removeInteractive();
    attempts = 0;

    if (gameState.attempted == 1) {
      this.speechBubble.setTexture("speechBubble1");
      this.time.delayedCall(3000, function () {
        config.audio.qa1.play();
      });
      this.qBoard.setTexture("qBoard1");
    } else if (gameState.attempted == 2) {
      this.speechBubble.setTexture("speechBubble2");
      this.time.delayedCall(3000, function () {
        config.audio.qa2.play();
      });
      this.qBoard.setTexture("qBoard2");
    } else if (gameState.attempted == 3) {
      this.speechBubble.setTexture("speechBubble3");
      this.time.delayedCall(3000, function () {
        config.audio.qa3.play();
      });
      this.qBoard.setTexture("qBoard3");
    } else if (gameState.attempted == 4) {
      this.speechBubble.setTexture("speechBubble4");
      this.time.delayedCall(3000, function () {
        config.audio.qa4.play();
      });
      this.qBoard.setTexture("qBoard4");
    } else if (gameState.attempted == 5) {
      this.speechBubble.setTexture("speechBubble5");
      this.time.delayedCall(3000, function () {
        config.audio.qa5.play();
      });
      this.qBoard.setTexture("qBoard5");
    } else if (gameState.attempted == 6) {
      this.speechBubble.setTexture("speechBubble6");
      this.time.delayedCall(3000, function () {
        config.audio.qa6.play();
      });
      this.qBoard.setTexture("qBoard6");
    } else if (gameState.attempted == 7) {
      this.speechBubble.setTexture("speechBubble7");
      this.time.delayedCall(3000, function () {
        config.audio.qa7.play();
      });
      this.qBoard.setTexture("qBoard7");
    } else if (gameState.attempted == 8) {
      this.speechBubble.setTexture("speechBubble8");
      this.time.delayedCall(3000, function () {
        config.audio.qa8.play();
      });
      this.qBoard.setTexture("qBoard8");
    } else if (gameState.attempted == 9) {
      this.speechBubble.setTexture("speechBubble9");
      this.time.delayedCall(3000, function () {
        config.audio.qa9.play();
      });
      this.qBoard.setTexture("qBoard9");
    } else if (gameState.attempted == 10) {
      this.speechBubble.setTexture("speechBubble10");
      this.time.delayedCall(3000, function () {
        config.audio.qa10.play();
      });
      this.qBoard.setTexture("qBoard10");
    }

    this.findDivisions();

    heliPosition = 644;
    clickCount = 0;

    this.heliHover.setPosition(-200, 363);

    this.heliHover.play("hover");

    this.moveHeli(3000, -200, 644);

    this.time.delayedCall(
      3100,
      function () {
        this.midpointArrayCreate();
        // console.log(midpointsArray);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.speechBubble,
      ease: "Quint.easeInOut",
      duration: 800,
      delay: 2500,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      scale: {
        getStart: () => 0,
        getEnd: () => 0.67,
      },
      yoyo: true,
      hold: 4000, //added delay for speech bubble
      loop: 0,
    });

    this.qBoardAppear(214, 8000, 0, 1, 0, 0.67); //added delay for qboard appearing

    //

    this.graphics = this.add.graphics();

    this.curve = new Phaser.Curves.Line(new Phaser.Math.Vector2(185, 515), new Phaser.Math.Vector2(1101.5, 515));

    this.linePoints = this.add.group();

    this.curve.draw(this.graphics);

    // this.numberLine.setFrame(0);

    array = this.linePoints.getChildren();

    divide = true;

    //

    joystickInput = true;

    this.numberLineDivide(divisions);

    // array[1].setFrame(3);

    for (let i = 0; i < array.length; i++) {
      array[i].setFrame(3);
    }

    this.time.delayedCall(
      7800,
      function () {
        // this.controlsSlideIn([this.joystick], 800, 633);
        // this.controlsSlideIn(
        //   [this.joystickHolder, this.dropButton],
        //   800,
        //   670
        // );
        // this.qBoardAppear(170, 1, 0, 0.67, 0);
        // this.qBoardAppear(214, 1, 0, 1, 0);
      },
      [],
      this
    );

    this.time.delayedCall(
      8000,
      function () {
        array[0].setFrame(1);

        // this.joystick.setInteractive({ cursor: "pointer" });

        //tbc

        this.leftUp.setInteractive({ cursor: "pointer" });
        this.rightUp.setInteractive({ cursor: "pointer" });
        this.dropUp.setInteractive({ cursor: "pointer" });

        this.joystickEnable = true;
      },
      [],
      this
    );
  }
  unitLengthCoverTime() {
    heliMoveDuration = 10000 / numberlineDivisions;

    // heliMoveDuration = 100/numberlineDivisions;

    // console.log(numberlineDivisions);
  }

  midpointArrayCreate() {
    this.findDivisions();

    midpointsArray.length = 0;

    for (var k = 0; k < numberlineDivisions + 1; k++) {
      // midpointsArray[k] = this.heliPosition + (k*this.unitLength);

      midpointsArray.push(this.heliHover.x + k * this.unitLength);

      // midpointsArray.push(this.unitLength);

      // midpointsArray.push(heliPosition);
    }
  }

  // prev functions

  colorchange() {
    for (let i = 0; i < array.length; i++) {
      array[i].setFrame(3);
    }
    for (var p = 0; p < array.length; p++) {
      if (this.heliHover.x - 20 < midpointsArray[p] && this.heliHover.x + 20 > midpointsArray[p]) {
        array[p].setFrame(1);
      }
    }

    if (levelCorrect) {
      array[clickCount].setFrame(2);
      // array[clickCount].setTexture('linePoint');
    } else if (!levelCorrect) {
      // array[clickCount].setTexture('redPoint');

      this.redDot.setPosition(array[clickCount].x, array[clickCount].y);
    }
  }

  numberLineDivide(divisions) {
    points = this.curve.getPoints(divisions);
    // console.log(points);

    for (var i = 0; i < points.length; i++) {
      var x = this.add.sprite(points[i].x, points[i].y, "linePoint").setFrame(0).setScale(0.67);
      this.linePoints.add(x);
      // console.log(this.linePoints);
      // this.linePoints.setVisible(false);
    }
  }

  controlsSlideIn(targets, start, end) {
    this.tweens.add({
      targets: targets,
      ease: "Sine.easeInOut",
      duration: 1,
      y: {
        getStart: () => start,
        getEnd: () => end,
      },
      yoyo: false,
      loop: 0,
    });
  }

  moveHeli(durationVal, start, end) {
    this.tweens.add({
      targets: this.heliHover,
      ease: "Sine.easeInOut",
      duration: durationVal,
      x: {
        getStart: () => start,
        getEnd: () => end,
      },
      yoyo: false,
      loop: 0,
      onStart: () => {
        config.audio.heliaudio.setLoop(true).setVolume(0.005).play();
      },
      onComplete: () => {
        this.tweens.add({
          targets: config.audio.heliaudio,
          ease: "Linear",
          volume: 0,
          duration: 200,
          onComplete: () => {
            config.audio.heliaudio.stop();
          },
        });
      },
    });
  }

  heliSnap(durationVal, start, delta) {
    this.tweens.add({
      targets: this.qBoard,
      ease: "Sine.easeInOut",
      duration: durationVal,
      x: {
        getStart: () => start - 430,
        getEnd: () => start + delta - 430,
      },
      yoyo: false,
      loop: 0,
      onStart: () => {
        config.audio.heliaudio.setLoop(true).setVolume(0.005).play();
      },
      onComplete: () => {
        this.tweens.add({
          targets: config.audio.heliaudio,
          ease: "Linear",
          volume: 0,
          duration: 200,
          onComplete: () => {
            config.audio.heliaudio.stop();
          },
        });
      },
    });

    this.tweens.add({
      targets: this.heliHover,
      ease: "Sine.easeInOut",
      duration: durationVal,
      x: {
        getStart: () => start,
        getEnd: () => start + delta,
      },
      yoyo: false,
      loop: 0,
      onComplete: () => {
        // this.toggleButton(this.rightDown,this.rightUp,true);
        // this.toggleButton(this.leftDown,this.leftUp,true);

        this.rightDown.setVisible(false);
        this.rightUp.setVisible(true);

        this.leftDown.setVisible(false);
        this.leftUp.setVisible(true);
      },
    });
  }

  qBoardAppear(newPos, delayVal, alphaStart, alphaEnd, scaleStart, scaleEnd) {
    this.qBoard.x = newPos;

    this.tweens.add({
      targets: this.qBoard,
      ease: "Quint.easeInOut",
      duration: 800,
      delay: delayVal,
      alpha: {
        getStart: () => alphaStart,
        getEnd: () => alphaEnd,
      },
      scale: {
        getStart: () => scaleStart,
        getEnd: () => scaleEnd,
      },
      yoyo: false,
      loop: 0,
    });
  }

  findDivisions() {
    if (gameState.attempted == 1) {
      numberlineDivisions = 8;
    } else if (gameState.attempted == 2) {
      numberlineDivisions = 8;
    } else if (gameState.attempted == 3) {
      numberlineDivisions = 3;
    } else if (gameState.attempted == 4) {
      numberlineDivisions = 10;
    } else if (gameState.attempted == 5) {
      numberlineDivisions = 4;
    } else if (gameState.attempted == 6) {
      numberlineDivisions = 6;
    } else if (gameState.attempted == 7) {
      numberlineDivisions = 10;
    } else if (gameState.attempted == 8) {
      numberlineDivisions = 5;
    } else if (gameState.attempted == 9) {
      numberlineDivisions = 6;
    } else if (gameState.attempted == 10) {
      numberlineDivisions = 12;
    }

    this.unitLength = lineLength / numberlineDivisions;
  }

  update() {
    // console.log(this.unitLength);
    this.findDivisions();
    // console.log(numberlineDivisions + " " + this.unitLength);

    // console.log(numberlineDivisions + " " + this.unitLength + " " + heliPosition);

    // console.log("gameState.attempted: " + gameState.attempted);

    // console.log("attempts " + attempts);

    // console.log(numberlineDivisions);

    // console.log(this.heliHover.x);
    // console.log(midpointsArray);

    this.colorchange();
  }
}
